import store from "@/state/store";
let userAccess = localStorage.getItem("userAccess") ? store.state.decrypt.userAccessList() : [];
let admin = store.state.decrypt.isAdmin();
export default [
  {
    path: "/finance/office-budget",
    name: "Office Budget",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("cascaded funds", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/office-budget"),
  },
  {
    path: "/finance/account-groups/:id?",
    name: "Account Group",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/finance/account-group"),
  },
  {
    path: "/finance/accounts/:group?/:id?",
    name: "Accounts",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/finance/accounts"),
  },
  {
    path: "/finance/expenditures/:id?",
    name: "Object of Expenditures",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("allocations to object of expenditure", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/expenditures"),
  },
  {
    path: "/finance/budget-utilization-request",
    name: "Budget Utilization Request and Status",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("burs", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/burs"),
  },
  {
    path: "/finance/disbursement",
    name: "Disbursement",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("disbursement", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/disbursement"),
  },
  {
    path: "/confirmation",
    name: "confirmation",
    meta: {
      authRequired: false,
    },
    component: () => import("./views/confirmation"),
  },
  {
    path: "/finance/templates",
    name: "Templates",
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("templates", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/finance-template"),
  },
  {
    path: "/finance/planning/cascaded-lib",
    name: "Pre-planning",
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("cascaded lib", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/pre-planning"),
  },
  {
    path: "/finance/settings",
    name: "Settings",
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("settings", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/settings"),
  },
  {
    path: "/administration/external-employees",
    name: "External Employees",
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("external employees", "administration")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/administration/external-employee"),
  },
  {
    path: "/finance/cashier",
    name: "Cashier",
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("cashier", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/cashier"),
  },
  {
    path: "/finance/collection",
    name: "Collection",
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("collection", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/collection"),
  },
  {
    path: "/finance/rcd",
    name: "Reports of Collections & Deposits",
    meta: {
      authRequired: false,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("rcd", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/rcd"),
  },
  {
    path: "/finance/jev",
    name: "jev",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("jev", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/jev"),
  },
  {
    path: "/finance/journals",
    name: "Journals",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("journals", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/journals"),
  },
  {
    path: "/finance/for-jev",
    name: "JEV Entries (OLD)",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("jev", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/for-jev"),
  },
  {
    path: "/finance/subsidiary-ledger",
    name: "Subsidiary Ledger",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("subsidiary ledger", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/subsidiary-ledger"),
  },
  {
    path: "/finance/general-ledger",
    name: "General Ledger",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("general ledger", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/general-ledger"),
  },
  {
    path: "/finance/planning/submitted-lib",
    name: "Planning Overview",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("submitted lib", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/finance-preplanning"),
  },
  {
    path: "/finance/budget-modification",
    name: "Re-alignment",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("budget modification", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/budget-modification"),
  },
  {
    path: "/finance/delivery-unit-services",
    name: "Delivery Unit Services",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("delivery unit services", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/delivery-unit-service"),
  },
  {
    path: "/finance/billing",
    name: "Billing",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("billing", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/billing"),
  },
  {
    path: "/finance/fees",
    name: "Fees",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("fees", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/fee"),
  },
  {
    path: "/finance/approved-budget",
    name: "Approved OPRC",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (displayMenu("approved budget", "finance")) {
          next();
        } else {
          next({ name: "404" });
        }
      },
    },
    component: () => import("./views/finance/approved-opcrs"),
  },
];
function displayMenu(menu, type) {
  let display = false;
  if (admin) {
    display = true;
  } else {
    display = userAccess.find((x) => x.Access.toLowerCase() === menu && x.Type.toLowerCase() === type) ? true : false;
  }
  return display;
}
